<template>
  <pie-chart
    v-if="reportChart"
    key="report-chart"
    :chart-data="reportChart"
    :tooltips-callback-cfg="tooltipsCallbackCfg"
  ></pie-chart>
</template>
<script>
import PieChart from "@/components/Base/PieChart";
import {
  COLOR_CHART_REPORT_STATUS_TASK_MANAGEMENT,
  COLOR_CHART_REPORT_TIMELINE_TASK_MANAGEMENT
} from "../../../helpers/color-chart-config";
export default {
  name: "report-chart",
  components: { PieChart },
  props: ["data", "type"],
  data() {
    return {
      tooltipsCallbackCfg: {
        title: {
          prefix: "Status"
        },
        label: true,
        afterLabel: {
          subfix: "tasks"
        }
      }
    };
  },
  computed: {
    reportChart() {
      return this.generateReportChart(this.data);
    }
  },
  methods: {
    generateReportChart(chartData) {
      const { labels, data } = chartData;
      return {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: labels.map(label =>
              this.type === "status"
                ? COLOR_CHART_REPORT_STATUS_TASK_MANAGEMENT[label]
                : COLOR_CHART_REPORT_TIMELINE_TASK_MANAGEMENT[label]
            ),
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
